import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import WebFont from "webfontloader";

ReactDOM.render(<App />, document.getElementById("root"));

WebFont.load({
  google: {
    families: ["Open Sans:300,400,700", "sans-serif"],
  },
});
